<template>
  <div class="teachers">
    <br>
    <div v-if="error">
      {{ error }}
      <Spinner />
    </div>
    <div
      v-if="teachers"
      class="layout"
    >
      <br>
      <div class="flex collapse">
        <h2>Teacher Records</h2>
        <div class="flex">
        <select
          v-model="grade"
        >
          <option
            value="Baby Class"
            selected="selected"
          >
          Baby Class
          </option>
          <option value="Middle Class">
            Middle Class
          </option>
          <option value="Reception Class">
            Reception
          </option>
          <option value="Grade 1">
            Grade 1
          </option>
          <option value="Grade 2">
            Grade 2
          </option>
          <option value="Grade 3">
            Grade 3
          </option>
          <option value="Grade 4">
            Grade 4
          </option>
          <option value="Grade 5">
            Grade 5
          </option>
          <option value="Grade 6">
            Grade 6
          </option>
          <option value="Grade 7">
            Grade 7
          </option>
          <option value="clear" selected>
            Show all
          </option>
        </select>
        </div>
        <ChevronUpIcon class="icone" @click="toggleTeachers" v-if="showTeachers" />
        <ChevronDownIcon class="icone" @click="toggleTeachers" v-if="!showTeachers" />
      </div>
      <div v-if="showTeachers">
        <div
          v-for="teacher in filteredTeachers"
          :key="teacher.uid"
        >
          <SchoolRecords :record="teacher" />
        </div>
      </div>
    </div>
    <div
      v-else
      class="card"
    >
      <Spinner />
    </div>
  </div>
</template>

<script>
import getListOfUsers from '@/composables/getListOfUsers'
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/vue/outline'
import SchoolRecords from './SchoolRecords.vue'
import Spinner from '@/components/Spinner.vue'
import { ref } from '@vue/reactivity'
import { watchEffect } from '@vue/runtime-core'

export default {
  name: 'TeacherRecords',
  components: { SchoolRecords, Spinner, ChevronDownIcon, ChevronUpIcon },
  setup () {
    const showTeachers = ref(false)
    const grade = ref(null)
    const filteredTeachers = ref(null)
    const { teachers, error, fetchListOfUsers } = getListOfUsers()

    fetchListOfUsers()

    watchEffect(() => {
      if (grade.value === null) {
        filteredTeachers.value = teachers.value
      }
      if (grade.value === 'clear') {
        filteredTeachers.value = teachers.value
      } else {
        filteredTeachers.value =
        teachers.value ? teachers.value.filter(teacher => teacher.grade === grade.value)
          : null
      }
    })

    const toggleTeachers = () => {
      showTeachers.value = !showTeachers.value
    }

    return { teachers, error, showTeachers, toggleTeachers, grade, filteredTeachers }
  }
}
</script>

<style>
.teachers h2 {
  color: #fff;
}
</style>
